export const getTableColumnsConfig = (tableKey) => (state) => state.table.tableColumns?.[tableKey] || null;
